"use client"

import { CaretDownOutlined } from "@ant-design/icons"
import Image, { StaticImageData } from "next/image"
import React from "react"

interface LanguageLabelProps {
  language: string
  urlLogo: StaticImageData
  checkShow?: boolean
  showIcon?: boolean
  showLogo?: boolean
}

export const LanguageLabel: React.FC<LanguageLabelProps> = ({ language, urlLogo, checkShow, showLogo, showIcon }) => {
  return (
    <div className="flex gap-2.5 items-center justify-center">
      {showLogo && (<div className="w-5 h-6">
        <Image src={urlLogo} alt="logo-vn" height={20} width={20} className="w-full h-full object-none" priority />
      </div>)}
      <span className="text-base leading-5.5 font-bold text-[#242f3e] hover:text-[#18af4e]">{language}</span>
      {showIcon !== false && <CaretDownOutlined className="text-[10px] leading-4" />}
    </div>
  )
}
